import {
	SITES_LOADING, SITES_SUCCESS, SITES_ERROR,
	FILTERS_UPDATE, COMBOS_SUCCESS,
} from '../actions/siteActions';

const today = new Date();
const fmt   = (d) => d.toISOString().split('T')[0];

const initialState = {
	sites:   [],
	loading: false,
	error:   null,

	// All network combos loaded once — { generation, manufacturer, omcId, tac }[]
	networkCombos: [],

	filters: {
		// Single select
		technology:     '4G',
		// Multi-select arrays — empty = "All"
		technologies:   ['4G'],
		vendors:        [],
		servers:        [],
		tacs:           [],
		// Activity status filter — 'Open' or 'Closed'
		activityStatus: 'Open',
		// Feature highlight filter — empty = all
		features:       [],
		// Wide window sent to API
		windowStart: fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 90)),
		windowEnd:   fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 90)),
		// Display window — instant recolour, zero API calls
		startDate:   fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 15)),
		endDate:     fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 15)),
	},
};

const siteReducer = (state = initialState, action) => {
	switch (action.type) {
					case SITES_LOADING:  return { ...state, loading: true,  error: null };
					case SITES_SUCCESS:  return { ...state, loading: false, sites: action.payload };
					case SITES_ERROR:    return { ...state, loading: false, error: action.payload };
					case FILTERS_UPDATE: return { ...state, filters: { ...state.filters, ...action.payload } };
					case COMBOS_SUCCESS: return { ...state, networkCombos: action.payload };
					default:             return state;
	}
};

export default siteReducer;